// 公用
const COMMON = {
    LOGIN: '/user/login',
    CHANGEPASSWORD: '/user/changepassword',
    COMMONUPLOADFILE: '/common/uploadfile',
    COMMONDEPTS: '/common/depts',
    COMMONZDDEPTS: '/common/zddepts',
    COMMONTRANSFERDEPTS: '/common/transferdepts',
    COMMONCASEREASONS: '/common/casereasons',
    COMMONDOCUSETYPES: '/common/docusetypes',

    USERDEPTUSERS: '/user/deptusers',

    DOCCATALOGDOCCATALOGS: '/doccatalog/doccatalogs',
    DOCCATALOGALLDOCCATALOGS: '/doccatalog/alldoccatalogs',
    DOCCATALOG: '/doccatalog',

    DOCINRECORDS: '/doc/inrecords',
    DOCINCODESEQUENCE: '/doc/in/codesequence',
    DOCINRECORD: '/doc/inrecord',

    DOCOUTRECORDS: '/doc/outrecords',
    DOCOUTDOCCATALOGS: '/doc/outdoccatalogs',
    DOCOUTRECORD: '/doc/outrecord',

    DOCRECEIVERECORDS: '/doc/receiverecords',
    DOCRECEIVEDOCCATALOGS: '/doc/receivedoccatalogs',
    DOCRECEIVEDOC: '/doc/receivedoc',

    DOCFEEDBACKS: '/doc/feedbacks',
    DOCDOCS: '/doc/docs',
    DOCFEEDBACK: '/doc/feedback',

    DOCSTOCKSTATS: '/doc/stockstats',
    DOCUSESTATS: '/doc/usestats',

    CASECASES: '/case/cases',
    CASEMYCASES: '/case/mycases',
    CASERECEIVECASES: '/case/receivecases',
    CASEDETAILS: '/case/details',
    CASE: '/case',
    CASERECEIVE: '/case/receive',
    CASERECORD: '/case/record',
    CASEPENALTY: '/case/penalty',
    CASECLOSE: '/case/close'
};

export { COMMON }



// WEBPACK FOOTER //
// ./src/store/sczdzf/constants/funcUrl.js